import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/main";

const { actions, types } = createActions({
  setIdentifier: ["identifier", "subMenu"],
});

const reducer = createReducer(initialState, {
  [types.SET_IDENTIFIER]: (state, { payload }) => ({
    ...state,
    identifier: payload.identifier,
    activeSubMenu: payload.subMenu,
  }),
});

export { reducer as default, types, actions };
